import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import client from "../../services/client";
import { ENDPOINTS } from "../../config";

// Thunk to onboard a vendor
export const onboardVendor = createAsyncThunk(
  "addVendor/onboardVendor",
  async (formData, thunkAPI) => {
    try {
      const response = await client.post(ENDPOINTS.addVendor, formData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);

// Initial state
const initialState = {
  vendorData: null,
  status: "idle", // idle / loading / succeeded / failed
  error: null,
};

// Vendor slice
const addVendorSlice = createSlice({
  name: "addVendor",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(onboardVendor.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(onboardVendor.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.vendorData = action.payload;
      })
      .addCase(onboardVendor.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload.message || "Something went wrong";
      });
  },
});

export default addVendorSlice.reducer;
